module.exports = __webpack_public_path__ + "img/08.16dfea4b.jpg";